import getExtensionFromPath from '@anm/helpers/getExtensionFromPath';
import getFromCdn from '@anm/helpers/getFromCdn';
import isUrlAbsolute from '@anm/helpers/is/isUrlAbsolute';

type GetActiveIconSrcProps = {
  isSelected: boolean;
  containActiveIcons: boolean;
  sufix?: string;
  initialSrc?: string;
};

const DEFAULT_SUFIX = '_active';

const getActiveIconSrc = ({
  sufix = DEFAULT_SUFIX,
  isSelected,
  containActiveIcons,
  initialSrc
}: GetActiveIconSrcProps) => {
  if (!initialSrc) return;

  const src = isUrlAbsolute(initialSrc) ? initialSrc : getFromCdn(initialSrc);

  const isBlobOrBase64 = src.startsWith('blob') || src.startsWith('data:');

  if (isBlobOrBase64 || !containActiveIcons) return src;

  const extension = getExtensionFromPath(src);

  const iconSrc = containActiveIcons && isSelected && extension? src.replace(`.${extension}`, `${sufix}.${extension}`) : src;

  return iconSrc;
};

export default getActiveIconSrc;
